// import axios from 'axios';

// export default axios.create({
//   baseURL: process.env.API_URL,
//   headers: { common: { 'Access-Control-Allow-Origin': '*' }, },
// });


import axios from 'axios';
import { DEFAULT_LOCALE } from 'Constants'
// import apiURL from './../constants';
const { host } = window.location
// const  host  = 'testing1.edubricz.com'
// const  host  = 'signup.edubricz.com'
// const  host  = 'signupstaging.edubricz.com'

// const  host  = '192.168.0.105:8002'
export const endPoint = `https://signup.edubricz.com/signupapi` //`https://${host}/signupapi`;

// export const endPoint = `http://192.168.88.26:8002/signupapi` //`https://${host}/signupapi`;

const lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : DEFAULT_LOCALE;

const axiosAPI = axios.create({
  baseURL: endPoint,
  headers: { common: {} }, //lang
});

// Attach token dynamically on every request so it's always fresh from localStorage
axiosAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = 'Token ' + token;
  } else {
    delete config.headers['Authorization'];
  }
  return config;
});

export default axiosAPI;
